import { useState } from 'react';
import { Typography, Container, Grid, Box, Button, InputLabel, IconButton, Paper } from '@mui/material';
import { UploadFile } from '@mui/icons-material';
import styles from './FingpayOnboarding.module.css';
import { useLocation, useNavigate } from 'react-router';
import { useEffect } from 'react';
import { registerFingpayCmsApi } from 'utils/API/Merchant APIs/MerchantApiCalls';
import { globalNotifyError, globalNotifySuccess } from 'views/utilities/AlertToast';
import Spinner from 'views/Components/LoadingSinner';
import { useDispatch, useSelector } from 'react-redux';
import { checkIsMerchantOrBcGlobal } from 'redux/merchantSlice';
import BcConvertModal from 'views/Components/BcConvertModal';

const FingpayOnboarding = () => {
    const dispatch = useDispatch();
    const location = useLocation();
    const navigate = useNavigate();
    const [files, setFiles] = useState({
        cheque: null,
        pan: null,
        aadhaar: null
    });
    const [isLoading, setLoading] = useState(false);
    const [fileNames, setFileNames] = useState({});
    const [filesToUpload, setFilesToUpload] = useState([]);
    const { chequeImage, panImage, aadhaarImage } = location.state || {};
    const { loading, agentType, pendingStatus } = useSelector((state) => state.merchant);
    const merchantModalOpen = agentType === 'Merchant';
    const isBcConvertPending = pendingStatus;
    const shouldshowEsign = localStorage.getItem('shouldshowEsign');
    const handleFileChange = (e, type) => {
        const file = e.target.files[0];
        if (!file) return;

        const maxSize = 500 * 1024; // 500KB

        if (file.size > maxSize) {
            globalNotifyError(`${type.charAt(0).toUpperCase() + type.slice(1)} file exceeds 500KB. Please upload a smaller file.`);
            e.target.value = null;
            return;
        }

        const reader = new FileReader();
        reader.onloadend = () => {
            setFiles((prev) => ({
                ...prev,
                [type]: reader.result // Base64 string
            }));
            setFileNames((prev) => ({
                ...prev,
                [type]: file.name
            }));
        };

        reader.readAsDataURL(file);
        e.target.value = null;
    };

    const handleSubmit = async () => {
        setLoading(true);
        const agentid = localStorage.getItem('id');
        const payload = { agentid, chequeimage: files.cheque, panimage: files.pan, ekycimage: files.aadhaar };
        const response = await registerFingpayCmsApi(payload);
        if (response?.status === 200) {
            globalNotifySuccess('Documents submitted successfully!');
            navigate('/cmsF/landingPage');
        }
        setLoading(false);
    };
    useEffect(() => {
        const uploadList = [];
        if (chequeImage) uploadList.push('cheque');
        if (panImage) uploadList.push('pan');
        if (aadhaarImage) uploadList.push('aadhaar');
        setFilesToUpload(uploadList);
        // eslint-disable-next-line
    }, []);
    useEffect(() => {
        dispatch(checkIsMerchantOrBcGlobal());
    }, [dispatch]);
    return (
        <>
            <Container maxWidth="md" className={styles.pageContainer}>
                <Typography variant="h4" className={styles.title}>
                    Upload Required Documents for CMS Onboarding
                </Typography>

                <Grid container spacing={4} className={styles.gridContainer}>
                    {filesToUpload?.map((type) => (
                        <Grid item xs={12} sm={4} key={type}>
                            <Paper elevation={3} className={styles.uploadCard}>
                                <InputLabel className={styles.label}>{type.charAt(0).toUpperCase() + type.slice(1)} Upload</InputLabel>
                                <Box className={styles.inputWrapper}>
                                    <input
                                        accept="image/*,"
                                        id={`upload-${type}`}
                                        type="file"
                                        style={{ display: 'none' }}
                                        onChange={(e) => handleFileChange(e, type)}
                                    />
                                    <label htmlFor={`upload-${type}`}>
                                        <IconButton color="primary" component="span" className={styles.uploadBtn}>
                                            <UploadFile fontSize="large" />
                                        </IconButton>
                                    </label>
                                    {fileNames[type] && (
                                        <Typography variant="body2" className={styles.fileName}>
                                            {fileNames[type]}
                                        </Typography>
                                    )}
                                </Box>
                            </Paper>
                        </Grid>
                    ))}
                </Grid>

                <Box mt={4} display="flex" justifyContent="center">
                    <Button variant="contained" color="primary" size="large" className={styles.submitButton} onClick={handleSubmit}>
                        Submit Documents
                    </Button>
                </Box>
            </Container>
            <Spinner loading={isLoading || loading} />
            {merchantModalOpen && (
                <BcConvertModal
                    isOpen={merchantModalOpen}
                    // handleclose={handleBcModalClose}
                    isPending={isBcConvertPending}
                    shouldshowEsign={shouldshowEsign}
                />
            )}
        </>
    );
};

export default FingpayOnboarding;
